<template>
  <div class="v-map-popup app" ref="container">
    <div
      :class="[
        'v-map-popup__content',
        popupVisible && 'v-map-popup__content--visible',
      ]"
      ref="content"
    >
      <slot />
      <div class="v-map-popup__close" @click="close">
        <svg
          width="10"
          height="10"
          viewBox="0 0 8 8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            transform="rotate(45 5.707 3.293)"
            fill="currentColor"
            fill-rule="evenodd"
          >
            <rect x="4.286" width="1.429" height="10" rx=".714" />
            <path
              d="M10 5c0 .394-.32.714-.714.714H.714a.714.714 0 110-1.428h8.572c.394 0 .714.32.714.714z"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    google: {
      type: Object,
      default: null
    },
    map: {
      type: Object,
      default: null
    },
    position: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      PopupClass: null,
      popup: null,
      popupVisible: false
    };
  },
  created() {
    this.PopupClass = this.createPopupClass();
  },
  watch: {
    position(position) {
      if (position) this.openAt(position);
    }
  },
  methods: {
    openAt(position) {
      this.popup = new this.PopupClass(
        new this.google.maps.LatLng(position.lat, position.lng),
        this.$refs.container,
        this.google
      );

      this.popup.setMap(this.map);
      this.popupVisible = true;
    },
    close() {
      this.popupVisible = false;
    },
    createPopupClass() {
      const Popup = function(position, container, google) {
        this.position = position;
        this.container = container;
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.container);
      };

      Popup.prototype = Object.create(this.google.maps.OverlayView.prototype);

      Popup.prototype.onAdd = function() {
        this.getPanes().floatPane.appendChild(this.container);
      };

      Popup.prototype.onRemove = function() {
        if (this.container.parentElement) {
          this.container.parentElement.removeChild(this.container);
        }
      };

      Popup.prototype.draw = function() {
        var divPosition = this.getProjection().fromLatLngToDivPixel(
          this.position
        );

        this.container.style.left = divPosition.x + "px";
        this.container.style.top = divPosition.y + "px";
      };

      return Popup;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";

.v-map-popup {
  cursor: auto;
  position: absolute;
  width: 220px;
  transform: translate(-50%, -33px);

  &__content {
    background-color: theme-color("white");
    position: absolute;
    bottom: 0;
    left: 0;
    width: 220px;
    background-color: white;
    padding: $spacer;
    border-radius: $border-radius;
    box-shadow: 0 18px 40px 0 rgba(0, 0, 0, 0.3);
    pointer-events: none;
    display: none;
    animation-name: reveal-up;
    animation-duration: 200ms;
    animation-delay: 50ms;
    animation-fill-mode: both;
    animation-timing-function: ease-out;

    &--visible {
      display: block;
      pointer-events: auto;
    }

    &::before {
      content: "";
      width: 20px;
      height: 20px;
      background-color: theme-color("white");
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 40%) rotate(45deg);
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    color: theme-color("border");
    cursor: pointer;
    line-height: 0;
  }
}
</style>
